import Tracking from '~/components/Abstracts/Tracking'
import ReviewPageContent from '~/components/UI/ReviewPageContent'

import getReviewPageStaticPropsFunction from '~/data/review-page-data'
import { ReviewPageData } from '~/data/review-page-data/serializer'

function Reviews(props: ReviewPageData) {
  return props ? (
    <>
      <ReviewPageContent {...props} />
      <Tracking template="page" />
    </>
  ) : null
}

export default Reviews

export const getStaticProps = getReviewPageStaticPropsFunction()
export const getStaticPaths = () => {
  return {
    paths: [],
    fallback: 'blocking',
  }
}
